(function () {
  var KM = window.KM3D = window.KM3D || {};
  KM.scenes = KM.scenes || {};
  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var q = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  KM.loadThree = function (cb) {
    if (window.THREE) return cb();
    if (q) { q.push(cb); return; }
    q = [cb];
    var s = document.createElement('script');
    s.src = CDN; s.async = true;
    s.onload = function () { var l = q; q = []; l.forEach(function (f) { f(); }); };
    s.onerror = function () { q = null; };
    document.head.appendChild(s);
  };

  KM.gear = function (T, o) {
    var n = o.n, a = Math.PI * 2 / n, ro = o.ro, ri = o.ri, s = new T.Shape(), i, k;
    var f = [[-0.5, ri], [-0.3, ri], [-0.17, ro], [0.17, ro], [0.3, ri]];
    for (i = 0; i < n; i++) {
      for (k = 0; k < f.length; k++) {
        var an = (i + f[k][0]) * a, x = Math.cos(an) * f[k][1], y = Math.sin(an) * f[k][1];
        if (i === 0 && k === 0) s.moveTo(x, y); else s.lineTo(x, y);
      }
    }
    s.closePath();
    if (o.hole) { var h = new T.Path(); h.absarc(0, 0, o.hole, 0, Math.PI * 2, true); s.holes.push(h); }
    var b = Math.min((ro - ri) * 0.12, o.d * 0.2);
    var g = new T.ExtrudeGeometry(s, { depth: o.d, bevelEnabled: true, bevelThickness: b, bevelSize: b, bevelSegments: 1, curveSegments: 4 });
    g.translate(0, 0, -o.d / 2);
    return g;
  };

  KM.spring = function (T, r, len, coils, tube, mat) {
    var C = new T.Curve();
    C.getPoint = function (t, o) {
      var a = t * coils * Math.PI * 2;
      return (o || new T.Vector3()).set(r * Math.cos(a), t * len, r * Math.sin(a));
    };
    return new T.Mesh(new T.TubeGeometry(C, coils * 12, tube, 6, false), mat);
  };

  KM.shadow = function (T, w, d, y, op) {
    var c = document.createElement('canvas'); c.width = c.height = 128;
    var g = c.getContext('2d'), gr = g.createRadialGradient(64, 64, 0, 64, 64, 64);
    gr.addColorStop(0, 'rgba(0,0,0,' + (op || 0.6) + ')'); gr.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = gr; g.fillRect(0, 0, 128, 128);
    var m = new T.Mesh(new T.PlaneGeometry(w, d), new T.MeshBasicMaterial({ map: new T.CanvasTexture(c), transparent: true, depthWrite: false }));
    m.rotation.x = -Math.PI / 2; m.position.y = y;
    return m;
  };

  KM.cylX = function (T, rt, rb, len, mat, seg) {
    var g = new T.CylinderGeometry(rt, rb, len, seg || 32);
    g.rotateZ(Math.PI / 2);
    return new T.Mesh(g, mat);
  };

  KM.mats = function (T) {
    var S = function (c, m, r, x) { var o = { color: c, metalness: m, roughness: r }; if (x) for (var k in x) o[k] = x[k]; return new T.MeshStandardMaterial(o); };
    return {
      steel: S(0xa9adb4, 1, 0.24), dark: S(0x6a6e75, 1, 0.34), chrome: S(0xdfe2e6, 1, 0.08),
      brass: S(0xe0aa45, 1, 0.28), yellow: S(0xffc10a, 0.08, 0.34), black: S(0x1c1c1f, 0.7, 0.55), shoe: S(0x34363b, 0.45, 0.6),
      rubber: S(0x26262a, 0.1, 0.85), white: S(0xf2f2ee, 0, 0.8), red: S(0xd23a1c, 0.3, 0.4),
      glass: new T.MeshPhysicalMaterial({ color: 0xbfe0ff, metalness: 0, roughness: 0.04, transparent: true, opacity: 0.26, side: T.DoubleSide, depthWrite: false, envMapIntensity: 1.6 }),
      oil: S(0xff6a00, 0, 0.2, { emissive: 0xff3c00, emissiveIntensity: 0.4, transparent: true, opacity: 0.78 }),
      glow: new T.MeshBasicMaterial({ color: 0xff5a08, transparent: true, opacity: 0, depthWrite: false, toneMapped: false })
    };
  };

  function makeEnv(T, r) {
    var s = new T.Scene(); s.add(new T.Mesh(new T.SphereGeometry(40, 16, 12), new T.MeshBasicMaterial({ color: 0x23262b, side: T.BackSide })));
    function p(w, h, x, y, z, c, i) {
      var m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ color: new T.Color(c).multiplyScalar(i), side: T.DoubleSide }));
      m.position.set(x, y, z); m.lookAt(0, 0, 0); s.add(m);
    }
    p(14, 3, 0, 10, 4, 0xffffff, 3.2); p(2.4, 12, -9, 2, 6, 0xffffff, 3.6); p(2.4, 12, 9, 2, 5, 0xffe9cc, 2.8);
    p(4, 9, 4, 3, -10, 0xdfeaff, 2.2); p(8, 2, 0, -3, 9, 0xff9a3c, 0.6); p(6, 6, -6, 1, -8, 0xffffff, 1.0);
    var g = new T.PMREMGenerator(r), t = g.fromScene(s, 0.03).texture; g.dispose();
    return t;
  }

  var cards = [], lastT = 0, running = false;

  function setup(c) {
    var T = window.THREE, mk = KM.scenes[c.name];
    if (!mk || c.ready) return;
    var w = c.kc.clientWidth || 400, h = c.kc.clientHeight || 300, r;
    try {
      r = new T.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power' });
    } catch (e) { return; }
    r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    r.setSize(w, h, false);
    r.outputEncoding = T.sRGBEncoding; r.toneMapping = T.ACESFilmicToneMapping; r.toneMappingExposure = 1.0;
    r.setClearColor(0x000000, 0);
    var scene = new T.Scene(); scene.environment = makeEnv(T, r);
    var key = new T.DirectionalLight(0xffffff, 0.5); key.position.set(4, 8, 6); scene.add(key);
    var rim = new T.DirectionalLight(0xffb066, 0.6); rim.position.set(-6, 3, -5); scene.add(rim);
    var M = KM.mats(T), sc = mk(T, M, KM);
    var pivot = new T.Group(); pivot.add(sc.root); scene.add(pivot);
    var cam = new T.PerspectiveCamera(sc.cam.fov || 30, w / h, 0.1, 200);
    var cv = r.domElement; cv.className = 'kc-gl'; cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;opacity:0;transition:opacity .5s';
    c.kc.appendChild(cv); c.kc.classList.add('kc--gl');
    var sv = c.kc.querySelector('.kc-svg'); if (sv) sv.style.visibility = 'hidden';
    c.r = r; c.scene = scene; c.cam = cam; c.sc = sc; c.pivot = pivot; c.cv = cv;
    c.t = sc.pose || 0; c.speed = 0; c.yaw = 0; c.pit = 0; c.mx = 0; c.my = 0; c.ready = true; c.dirty = true;
    c.fit = function () {
      var W = c.kc.clientWidth || 400, H = c.kc.clientHeight || 300;
      r.setSize(W, H, false); cam.aspect = W / H;
      var k = Math.max(1, (4 / 3) / cam.aspect), p = sc.cam.p, l = sc.cam.l;
      cam.position.set(l[0] + (p[0] - l[0]) * k, l[1] + (p[1] - l[1]) * k, l[2] + (p[2] - l[2]) * k);
      cam.lookAt(l[0], l[1], l[2]); cam.updateProjectionMatrix(); c.dirty = true;
    };
    c.fit();
    if (window.ResizeObserver) new ResizeObserver(c.fit).observe(c.kc);
    sc.update(c.t, 0, 0);
    r.render(scene, cam);
    requestAnimationFrame(function () { cv.style.opacity = 1; });
    c.el.addEventListener('mousemove', function (e) {
      var b = c.el.getBoundingClientRect();
      c.mx = (e.clientX - b.left) / b.width - 0.5; c.my = (e.clientY - b.top) / b.height - 0.5;
    });
    c.el.addEventListener('mouseleave', function () { c.mx = 0; c.my = 0; });
    start();
  }

  function isActive(c) {
    return c.el.classList.contains('is-live') || c.el.matches(':hover') || c.el.matches(':focus-visible');
  }

  function frame(now) {
    var dt = Math.min(0.05, (now - lastT) / 1000 || 0.016); lastT = now;
    var busy = false;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i]; if (!c.ready || !c.vis) continue;
      var on = isActive(c), tgt = on && !reduce ? 1 : 0;
      c.speed += (tgt - c.speed) * Math.min(1, dt * 5);
      if (Math.abs(c.speed - tgt) < 0.004) c.speed = tgt;
      var ty = reduce ? 0 : c.mx * 1.1 + (on ? Math.sin(now / 1700) * 0.12 : 0), tp = reduce ? 0 : c.my * 0.5;
      var dy = ty - c.yaw, dp = tp - c.pit;
      c.yaw += dy * Math.min(1, dt * 6); c.pit += dp * Math.min(1, dt * 6);
      var moving = c.speed > 0 || Math.abs(dy) > 0.0015 || Math.abs(dp) > 0.0015 || c.dirty;
      if (!moving) continue;
      busy = true; c.dirty = false;
      c.t += dt * c.speed;
      c.pivot.rotation.set(c.pit, c.yaw, 0);
      c.sc.update(c.t, dt * c.speed, c.speed);
      c.r.render(c.scene, c.cam);
    }
    requestAnimationFrame(frame);
  }

  function start() { if (running) return; running = true; requestAnimationFrame(frame); }

  KM.init = function () {
    var els = document.querySelectorAll('.category-card[data-scene]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var c = e.target.__km; if (!c) return;
        c.vis = e.isIntersecting;
        if (e.isIntersecting && !c.ready && !c.busy) {
          c.busy = true;
          KM.loadThree(function () { setup(c); });
        }
      });
    }, { rootMargin: '150px' });
    els.forEach(function (el) {
      if (el.__km) return;
      var kc = el.querySelector('.kc'); if (!kc) return;
      var c = { el: el, kc: kc, name: el.getAttribute('data-scene') };
      el.__km = c; cards.push(c); io.observe(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', KM.init); else KM.init();
  document.addEventListener('shopify:section:load', KM.init);
})();
(function () {
  var KM = window.KM3D;
  KM.bevel = function (T, o) {
    // axis = Y, wide end at y=0 (radius r0), narrow end at y=h (radius r1)
    var gr = new T.Group(), r0 = o.r0, r1 = o.r1, h = o.h, N = o.n, th = o.th, tw = o.tw;
    var body = new T.Mesh(new T.CylinderGeometry(r1, r0, h, 40, 1, false), o.mat); body.position.y = h / 2; gr.add(body);
    var sl = Math.sqrt((r0 - r1) * (r0 - r1) + h * h), phi = Math.atan2(h, r1 - r0);
    var mx = (r0 + r1) / 2, my = h / 2, nx = Math.sin(phi), ny = -Math.cos(phi);
    var inst = new T.InstancedMesh(new T.BoxGeometry(sl, th, tw), o.mat, N), d = new T.Object3D(), i;
    for (i = 0; i < N; i++) {
      var yaw = i / N * Math.PI * 2, m = new T.Matrix4(), q = new T.Matrix4();
      m.makeRotationY(yaw);
      q.makeTranslation(mx + nx * th * 0.45, my + ny * th * 0.45, 0).multiply(new T.Matrix4().makeRotationZ(phi));
      m.multiply(q); inst.setMatrixAt(i, m);
    }
    gr.add(inst);
    return gr;
  };
})();